import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { report } from 'node:process';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { reportListInterface } from 'src/app/util/interfaces/reportList';
import { reportOptionsInterface } from 'src/app/util/interfaces/reportOptions';

import { spreadsheetInterface } from 'src/app/util/interfaces/spreadsheet';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ReportPageService {
	private getFormOptionsUrl = environment.baseApiUrl + 'report/params';
	private reportListUrl = environment.baseApiUrl + 'report';
	private deleteReportUrl = environment.baseApiUrl + 'report/{idReport}';
	private updateReportUrl = environment.baseApiUrl + 'report/{idReport}';
	private createReportUrl = environment.baseApiUrl + 'report';
	private reportParamUrl = environment.baseApiUrl + 'report/{idReport}/params';
	private getReportUrl = environment.baseApiUrl + 'report/{idReport}';
	private getReportColumntUrl = environment.baseApiUrl + 'report/reportcolumn';
	private getCockpitReportUrl = environment.baseApiUrl + 'cockpit/indicator/{idIndicator}?{qryString}';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient,
		private httpClient: HttpClient
	) {}

	getReportList(): Observable<reportListInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<JSON>(this.reportListUrl, { headers: headers }).pipe(
			map((reportList: any) => {
				const newReportList: reportListInterface[] = [];
				if (reportList && reportList.length > 0) {
					reportList.forEach((report: any) => {
						const newReport: reportListInterface = {
							id: report.id,
							name: report.report_name,
							type: 'request',
							type_label: 'lbl_geral_chamado',
							sub_type: '',
						};
						newReportList.push(newReport);
					});
				}
				return newReportList;
			})
		);
	}

	// getSearchColumn() : Observable<SearchColumnInterface[]> {
	//   let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.AuthLoginService.getSessionToken(), 'Content-Type': 'application/json;charset=UTF-8' });
	//   // let getReportColumntUrl = this.getReportColumntUrl.replace('{idReport}', idReport)
	//   return this.httpClient.get<any[]>(this.getReportColumntUrl, { headers: headers });
	// }

	getFormOptions(parameterType: string, grabItems: boolean): Observable<genericFormInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http
			.get<JSON[]>(this.getFormOptionsUrl, { headers: headers, params: { paramType: parameterType, grabItems: grabItems } })
			.pipe(
				map((formOptionsRes) => {
					const newFormOptionsArray: genericFormInterface[] = [];
					formOptionsRes.forEach((formOption: any) => {
						const newFormOption: genericFormInterface = {
							id: formOption.id,
							inputType: formOption.inputType,
							name: formOption.name,
							label: formOption.label,
							items: formOption.items,
							values: formOption.values,
							rawValues: formOption.rawValues,
							disabled: formOption.disabled,
							outItems: [],
							filterItem: [],
							filterValues: [],
						};

						newFormOptionsArray.push(newFormOption);
					});

					return newFormOptionsArray;
				})
			);
	}

	createReport(reportName: string, reportParameters: genericFormInterface[]): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			report_name: reportName,
			params: [],
		};

		for (const reportForm of reportParameters) {
			const newParameter = {
				id_param: reportForm.id,
				param_value: [],
			};

			for (const [index, value] of reportForm.values.entries()) {
				if (reportForm.inputType === 'multi-select') newParameter.param_value.push(reportForm.rawValues[index]);
				else newParameter.param_value.push(value);
			}

			body.params.push(newParameter);
		}
		return this.http.post<JSON>(this.createReportUrl, body, { headers: headers });
	}

	updateReport(idReport: string, reportName: string, reportParameters: genericFormInterface[]): Observable<JSON> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			report_name: reportName,
			params: [],
		};

		for (const reportForm of reportParameters) {
			const newParameter = {
				id_param: reportForm.id,
				param_value: [],
			};

			for (const [index, value] of reportForm.values.entries()) {
				if (reportForm.inputType === 'multi-select') newParameter.param_value.push(reportForm.rawValues[index]);
				else newParameter.param_value.push(value.toString());
			}

			body.params.push(newParameter);
		}
		const updateReportUrl = this.updateReportUrl.replace('{idReport}', idReport);
		return this.http.put<JSON>(updateReportUrl, body, { headers: headers });
	}

	deleteReport(idReport: string): Observable<JSON> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteReportUrl = this.deleteReportUrl.replace('{idReport}', idReport);
		return this.http.delete<JSON>(deleteReportUrl, { headers: headers });
	}

	getReportData(idReport: string, getter_limit?: number, qryString?: string): Observable<spreadsheetInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let getReportUrl = this.getReportUrl.replace('{idReport}', idReport);
		if (getter_limit || getter_limit === 0 || qryString) {
			getReportUrl += '?';
		}
		if (getter_limit || getter_limit === 0) {
			getReportUrl += `getter_limit=${getter_limit}`;
		}
		if (qryString) {
			getReportUrl += '&' + qryString;
		}
		return this.http.get<any>(getReportUrl, { headers: headers }).pipe(
			map((reportDataRes) => {
				return this.mapSpreadsheet(reportDataRes);
			})
		);
	}

	getCockpitReportData(idIndicator: string, getterLimit: number, genericParameter1?: string): Observable<spreadsheetInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getCockpitReportUrl = this.getCockpitReportUrl
			.replace('{idIndicator}', idIndicator)
			.replace(
				'{qryString}',
				`getterLimit=${getterLimit}&dateRange=${localStorage.getItem('ckpL') ? localStorage.getItem('ckpL') : '0'}&getType=data&genericParam1=${genericParameter1}`
			);
		return this.http.get<any>(getCockpitReportUrl, { headers: headers }).pipe(
			map((reportDataRes) => {
				return this.mapSpreadsheet(reportDataRes);
			})
		);
	}

	getReportParams(idReport: string, availableForm: genericFormInterface[]): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const reportParameterUrl = this.reportParamUrl.replace('{idReport}', idReport);

		const availableFormDict = {};
		for (const formItem of availableForm) {
			availableFormDict[formItem.name] = formItem;
		}

		return this.http.get<JSON>(reportParameterUrl, { headers: headers }).pipe(
			map((reportParameter: any) => {
				for (const parameter of reportParameter.params) {
					if (availableFormDict[parameter.id_param]) {
						const formItem: genericFormInterface = availableFormDict[parameter.id_param];
						formItem.values = [];
						formItem.rawValues = [];
						if (formItem.inputType === 'multi-select') {
							//Value in items
							for (const item of formItem.items) {
								if (parameter.param_value.includes(item.values[0].toString())) {
									formItem.values.push(item);
									formItem.rawValues.push(item.values[0]);
								}
							}
						} else if (formItem.inputType.includes('date')) {
							//No join with §
							if (Number.isNaN(Date.parse(parameter.param_value[0])))
								availableFormDict[parameter.id_param].periodType = parameter.param_value[0];
							availableFormDict[parameter.id_param].values = parameter.param_value;
						} else {
							availableFormDict[parameter.id_param].values[0] = parameter.param_value.join('§');
						}
						availableFormDict[parameter.id_param].selected = true;
					}
				}

				reportParameter.params = availableForm;
				return reportParameter;
			})
		);
	}

	mapSpreadsheet(reportDataRes: any): spreadsheetInterface {
		const newSpreadsheet: spreadsheetInterface = {
			id: '',
			title: '',
			selectedItemAxis: [-1, -1],
			sort: { sort_column: 0, sort_down: true },
			hiddenLines: [],
			lines: [],
			dataNull: false,
		};

		if (reportDataRes.DATA.length === 0) newSpreadsheet.dataNull = true;

		const headerLine: spreadsheetInterface['lines'][number] = {
			generatedBlank: false,
			cells: [],
		};

		for (const column_name of reportDataRes.COLUMNS) {
			const newHeaderCell: spreadsheetInterface['lines'][number]['cells'][number] = {
				header_cell: { search_value: '' },
				item_name: column_name,
				item_value: column_name,
			};
			headerLine.cells.push(newHeaderCell);
		}
		newSpreadsheet.lines.push(headerLine);

		for (const line of reportDataRes.DATA) {
			const newLine: spreadsheetInterface['lines'][number] = {
				generatedBlank: false,
				cells: [],
			};
			for (const cell of line) {
				const newCell: spreadsheetInterface['lines'][number]['cells'][number] = {
					header_cell: { search_value: '' },
					item_name: cell,
					item_value: cell,
				};
				newLine.cells.push(newCell);
			}
			newSpreadsheet.lines.push(newLine);
		}

		return newSpreadsheet;
	}
}
